import { LinePath } from '@visx/shape';
import { curveMonotoneX, CurveFactory } from 'd3-shape';
import type { ScaleLinear, ScaleTime } from 'd3-scale';
import { getSafeZero } from '../utils';

interface Props {
  data: number[];
  xSelect: (date: number) => number;
  ySelectLow: (date: number) => number;
  ySelectHigh: (date: number) => number;
  xScale: ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
  fillPos?: string;
  fillNeg?: string;
  endX?: number;
  curve?: CurveFactory;
}

const Range = ({
  data,
  xSelect,
  ySelectLow,
  ySelectHigh,
  xScale,
  yScale,
  fillPos = 'white',
  fillNeg,
  endX,
  curve,
}: Props) => {
  const end = endX || xScale.domain()[1];
  const zero = getSafeZero(yScale);
  return (
    <>
      {yScale.domain()[1] > 0 && (
        <svg y="0" x="0" width={xScale(end)} height={zero}>
          <LinePath
            data={data}
            x={(d) => xScale(xSelect(d)) as number}
            curve={curve || curveMonotoneX}
          >
            {({ path }) => {
              path.y((d) => yScale(ySelectLow(d)) as number);
              const low = path(data.slice().reverse());
              path.y((d) => yScale(ySelectHigh(d)) as number);
              const high = path(data);
              if (high === null || low === null) return null;
              return (
                <path d={low + ' L' + high.slice(1) + 'Z'} fill={fillPos} />
              );
            }}
          </LinePath>
        </svg>
      )}
      {yScale.domain()[0] < 0 && (
        <svg y={zero} x="0" width={xScale(end)} height="100%">
          <LinePath
            data={data}
            x={(d) => xScale(xSelect(d)) as number}
            curve={curve || curveMonotoneX}
          >
            {({ path }) => {
              path.y((d) => (yScale(ySelectLow(d)) as number) - zero);
              const low = path(data.slice().reverse());
              path.y((d) => (yScale(ySelectHigh(d)) as number) - zero);
              const high = path(data);
              if (high === null || low === null) return null;
              return (
                <path
                  d={low + ' L' + high.slice(1) + 'Z'}
                  fill={fillNeg || fillPos}
                />
              );
            }}
          </LinePath>
        </svg>
      )}
    </>
  );
};

export default Range;
